import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import Field from "../../../../../components/shared/Form/Field";
import Select from "../../../../../components/shared/inputs/Select";
import Table from "../../components/Table";

function Filters({ config }: any) {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext();
    const filters = useWatch({ control, name: "filters" });
    const defaultFilter = useWatch({ control, name: "defaultFilter" });

    const map = useMemo(() => {
        return config.reduce((total: any, filter: any) => {
            total[filter.name] = filter;
            return total;
        }, {});
    }, [config]);

    const visible = useMemo(() => {
        if (!filters) return [];
        return filters.filter(({ hide }: any) => !hide);
    }, [filters]);

    useEffect(() => {
        if (!defaultFilter || !filters) return;
        const filter = filters.find((item: any) => item.accessor === defaultFilter);
        if (filter?.hide) setValue("defaultFilter", "");
    }, [setValue, filters, defaultFilter]);

    return (
        <div className="tw-flex tw-flex-col tw-h-full tw-gap-4">
            <div className="tw-max-w-xs">
                <Field name="defaultFilter" label={t("default-filter")} shouldUnregister={false}>
                    <Select allowClear>
                        {visible.map((filter: any) => (
                            <Select.Item key={filter.accessor} value={filter.accessor}>
                                {map[filter.accessor]?.label}
                            </Select.Item>
                        ))}
                    </Select>
                </Field>
            </div>

            <div className="tw-flex-1 tw-min-h-0">
                <Table
                    columns={config}
                    fieldName="filters"
                    isFilter={true}
                    canSort={false}
                />
            </div>
        </div>
    );
}

export default Filters;
